import axios from "axios";

import Constants from "../../utils/Constantes";

const API_URL = Constants.api_url;
const GET_NOMINAS_YEARS = `${API_URL}/nomina/intervalo`;
const GET_NOMINAS_JSON = `${API_URL}/nomina/`;
const GET_NOMINAS_PDF = `${API_URL}/nomina/nominaPdf/`;
const GET_BORRADOR_NOMINA = `${API_URL}/nomina/getPDF_borradorNomina/`;
const GET_CUADRE_NOMINA = `${API_URL}/nomina/cuadre/`;
const AUMENTAR_CUADRE_NOMINA = `${API_URL}/nomina/cuadre/aumentar`;
const DISMINUIR_CUADRE_NOMINA = `${API_URL}/nomina/cuadre/disminuir`;

/**
 * Obtiene los datos
 *
 * @param {String} token
 * @returns data
 */
export async function getYears(token) {
  
  return await axios({
    method: "GET",
    url: GET_NOMINAS_YEARS,
  })
    .then((response) => response.data)
    .catch(
      (response) =>
        (response.data = "Error: Fallo en recoger los datos de nómina")
    );
}
/**
 * Obtiene los datos
 *
 * @param {String} token
 * @returns data
 */
export async function getJSON(year, mes) {
  return await axios({
    method: "GET",
    url: `${GET_NOMINAS_JSON}${year}/${mes}`,
    // headers: { Authorization: token },
  })
    .then((response) => {
      
      return response.data;
    })
    .catch(
      (response) =>{
        
        if (response.response.status  === 404) {
          return (response.data = "Error: La nómina buscada no está disponible")
        }else{
          return (response.data = "Error: Fallo en recoger los datos de la nómina")
        }
        
       
      }
        
    );
}
/**
 * Obtiene los datos
 *
 * @param {String} token
 * @returns data
 */
export async function getPDF(year, mes) {
  return await axios({
    method: "GET",
    url: `${GET_NOMINAS_PDF}${year}/${mes}`,
    responseType: "blob",
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en recoger el PDF de nómina")
    );
}

export async function getPDFBorradorNomina(mes, year) {
  return await axios({
    method: "GET",
    url: `${GET_BORRADOR_NOMINA}${mes}/${year}`,
    responseType: "blob",
    // headers: { Authorization: token },
  })
    .then((response) => response.data)
    .catch(
      (response) => {
        
          return (response.data = "Error: Fallo en recoger el PDF de nómina")
      }
    );
}
export async function getCuadre() {
  return await axios({
    method: "GET",
    url: `${GET_CUADRE_NOMINA}`,
  })
    .then((response) => response.data)
    .catch((response) => (response.data = "Error: Fallo en recoger el Cuadre"));
}
export async function aumentarCuadre() {
  return await axios({
    method: "PUT",
    url: `${AUMENTAR_CUADRE_NOMINA}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en aumentar el Cuadre")
    );
}
export async function disminuirCuadre() {
  return await axios({
    method: "PUT",
    url: `${DISMINUIR_CUADRE_NOMINA}`,
  })
    .then((response) => response.data)
    .catch(
      (response) => (response.data = "Error: Fallo en disminuir el Cuadre")
    );
}
